// src/utils/safeUuid.js
/* eslint-env browser */

export default function safeUuid() {
  // Only use window.* to avoid ESLint no-undef/no-restricted-globals on self/globalThis
  const w = typeof window !== "undefined" ? window : undefined;
  const c = w && (w.crypto || w.msCrypto);

  // Modern, built-in UUID
  if (c && typeof c.randomUUID === "function") {
    try {
      return c.randomUUID();
    } catch {
      // fall through
    }
  }

  // RFC4122 v4 via getRandomValues (preferred fallback)
  if (c && typeof c.getRandomValues === "function") {
    const bytes = new Uint8Array(16);
    c.getRandomValues(bytes);
    // Set version (4) and variant (10xxxxxx)
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(
      16,
      20
    )}-${hex.slice(20)}`;
  }

  // Last-resort (non-crypto) fallback
  const rnd32 = () =>
    (Math.random() * 0xffffffff) >>> 0; // uint32
  const toHex8 = (n) => n.toString(16).padStart(8, "0");

  const a = rnd32();
  const b = rnd32();
  const c2 = rnd32();
  const d = rnd32();

  // Craft something UUID-like; not cryptographically strong
  // Ensure version 4 and variant 10 in the appropriate nibbles
  const part1 = toHex8(a);
  const part2 = toHex8(b).slice(0, 4);
  const part3 = `4${toHex8(b).slice(1, 4)}`; // version 4
  const part4 = `8${toHex8(c2).slice(1, 4)}`; // variant 10
  const part5 = (toHex8(d) + toHex8(c2).slice(0, 4)).slice(0, 12);

  return `${part1}-${part2}-${part3}-${part4}-${part5}`;
}
